import { baseStudio } from './baseUrl';
import { STUDIO_ID_SUFFIX } from 'util/constants';

export const videosPack = [
  {
    name: `Video 1${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}videoStudio/videoStudio1.jpg`,
    url: `${baseStudio}videoStudio/videoStudio1.mp4`,
  },
  {
    name: `Video 2${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}videoStudio/videoStudio2.jpg`,
    url: `${baseStudio}videoStudio/videoStudio2.mp4`,
  },
  {
    name: `Video 3${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}videoStudio/videoStudio3.jpg`,
    url: `${baseStudio}videoStudio/videoStudio3.mp4`,
  },
  {
    name: `Video 4${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}videoStudio/videoStudio4.jpg`,
    url: `${baseStudio}videoStudio/videoStudio4.mp4`,
  },
  {
    name: `Video 5${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}videoStudio/videoStudio5.jpg`,
    url: `${baseStudio}videoStudio/videoStudio5.mp4`,
  },
  {
    name: `Video 6${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}videoStudio/videoStudio6.jpg`,
    url: `${baseStudio}videoStudio/videoStudio6.mp4`,
  },
];
